import { GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse } from '@iwoca/lapi-client/introducer_portal';
import { t } from '@lingui/core/macro';

type TRequestType =
  GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse['data']['additional_info_requests'][number]['request_type'];

const NON_RENDERABLE_REQUEST_TYPES = new Set<TRequestType>([
  'ADG',
  'CHECK_OPTIONAL_ADG',
  'RE_LINK_OB',
  'OB_LINK_ERROR',
]);

export const isAdditionalInfoRequestRenderable = (
  type: TRequestType,
): boolean => !NON_RENDERABLE_REQUEST_TYPES.has(type);

export const getAdditionalInfoMessage = (
  type: GetApiIntroducerPortalIntroducerApplicationDocumentFeedbackResponse['data']['additional_info_requests'][number]['request_type'],
): { label: string; description: string } | null => {
  switch (type) {
    case 'LOAN_PURPOSE':
      return {
        label: t`Loan purpose`,
        description: t`Please provide us with a brief explanation of the purpose of the loan.`,
      };
    case 'DATE_OF_FOUNDATION':
      return {
        label: t`Date of foundation`,
        description: t`Please send us a confirmation of the company's founding date or alternatively upload the trade licence (under "Other documents").`,
      };
    case 'TRADE_LICENSE':
      return {
        label: t`Trade licence`,
        description: t`Please send us the trade licence or alternatively upload it (under "Other documents").`,
      };
    case 'LEGAL_FORM':
      return {
        label: t`Legal form`,
        description: t`Please provide us with a brief explanation of the legal form or alternatively upload the trade licence (under "Other documents").`,
      };
    case 'NO_ACCOUNT_NUMBER':
      return {
        label: t`Missing Statements`,
        description: t`Please upload bank statements for the last 90 days in PDF format (under "Bank Statements"). Make sure they include the balances and all transactions. We require statements for all accounts that process more than 10% of the total business revenue.`,
      };
    case 'TURNOVER_CLARIFICATION':
      return {
        label: t`Turnover clarification`,
        description: t`As the turnover on the submitted bank statements differs from the information in the application, please send a brief explanation to partner@iwoca.de. If there are additional accounts, please also upload the current statements for these (under "Bank Statements").`,
      };
    case 'PERSONAL_ID':
      return {
        label: t`Personal ID`,
        description: t`Please upload the front and back of your client's ID (under "Other documents").`,
      };
    case 'ADG':
    case 'CHECK_OPTIONAL_ADG':
      return null;
    default:
      return null;
  }
};
